import { useState } from "react";
import { IconX, IconPackage, IconAlertTriangle, IconCheck } from "@tabler/icons-react";
import toast from "react-hot-toast";
import { useFetchOrderLineItemsWithStock, useSplitOrderMutation } from "../../../apis/orderApis";
 
interface Props {
  open: boolean;
  onClose: () => void;
  orderId: string;
  awbNumber: string;
  onSuccess: () => void;
  isSidebar?: boolean;
}
 
// export default function OrderSplitModal({ open, onClose, orderId, awbNumber, onSuccess }: Props) {
//   const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());
 
//   const { data: lineItems, isLoading } = useFetchOrderLineItemsWithStock(orderId);
//   const { mutate: splitOrder, isPending: isSplitting } = useSplitOrderMutation(orderId);
 
//   if (!open) return null;
 
//   const availableItems = lineItems?.filter((item) => item.hasStock && !item.isSplit) ?? [];
//   const unavailableItems = lineItems?.filter((item) => !item.hasStock && !item.isSplit) ?? [];
//   const alreadySplitItems = lineItems?.filter((item) => item.isSplit) ?? [];
 
//   const allAvailableChecked =
//     availableItems.length > 0 && availableItems.every((item) => selectedIds.has(item.id));
//   const someAvailableChecked = selectedIds.size > 0 && !allAvailableChecked;
 
//   const toggleAll = () => {
//     if (allAvailableChecked) {
//       setSelectedIds(new Set());
//     } else {
//       setSelectedIds(new Set(availableItems.map((item) => item.id)));
//     }
//   };
 
//   const toggleOne = (id: string) => {
//     setSelectedIds((prev) => {
//       const next = new Set(prev);
//       next.has(id) ? next.delete(id) : next.add(id);
//       return next;
//     });
//   };
 
//   const handleSplit = () => {
//     if (selectedIds.size === 0) {
//       toast.error("Please select at least one item to split");
//       return;
//     }
//     splitOrder(
//       { selectedItemIds: Array.from(selectedIds) },
//       {
//         onSuccess: (data) => {
//           toast.success(
//             `Order split successfully! Child order: ${data.childAwb}`
//           );
//           setSelectedIds(new Set());
//           onSuccess();
//           onClose();
//         },
//         onError: (error: any) => {
//           toast.error(error?.message ?? "Failed to split order. Please try again.");
//         },
//       }
//     );
//   };
 
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
//       <div className="bg-white rounded-2xl w-full max-w-2xl shadow-2xl overflow-hidden">
 
//         {/* Header */}
//         <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
//           <div>
//             <h2 className="text-lg font-semibold text-[#212121]">Split Order</h2>
//             <p className="text-xs text-gray-400 mt-0.5">AWB: {awbNumber}</p>
//           </div>
//           <button
//             onClick={onClose}
//             className="p-1.5 rounded-full hover:bg-gray-100 transition"
//           >
//             <IconX size={18} className="text-gray-500" />
//           </button>
//         </div>
 
//         {/* Body */}
//         <div className="px-6 py-4 max-h-[60vh] overflow-y-auto space-y-4">
//           {isLoading ? (
//             <div className="flex justify-center items-center py-12">
//               <div className="w-8 h-8 border-2 border-[#FBD037] border-t-transparent rounded-full animate-spin" />
//             </div>
//           ) : (
//             <>
//               {/* Info banner */}
//               <div className="bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 text-sm text-amber-700">
//                 <strong>How it works:</strong> Items with available stock will be moved into a new child
//                 order (<strong>{awbNumber}-1</strong>) with status <strong>New Order</strong>.
//                 Items without stock remain in this order (blocked).
//               </div>
 
//               {/* Items with stock — selectable */}
//               {availableItems.length > 0 && (
//                 <div className="border border-green-200 rounded-xl overflow-hidden">
//                   <div className="flex items-center justify-between px-4 py-2.5 bg-green-50 border-b border-green-200">
//                     <div className="flex items-center gap-2">
//                       <IconCheck size={16} className="text-green-600" />
//                       <span className="text-sm font-medium text-green-700">
//                         In Stock ({availableItems.length})
//                       </span>
//                     </div>
//                     {/* Select all */}
//                     <label className="flex items-center gap-2 text-xs text-green-600 cursor-pointer">
//                       <div className="relative">
//                         <input
//                           type="checkbox"
//                           checked={allAvailableChecked}
//                           ref={(el) => { if (el) el.indeterminate = someAvailableChecked; }}
//                           onChange={toggleAll}
//                           className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300
//                             checked:border-[#FBD037] bg-white checked:bg-[#FBD037]"
//                         />
//                         <span className="absolute text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0
//                           top-1/2 left-[8px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
//                           ✓
//                         </span>
//                       </div>
//                       Select all
//                     </label>
//                   </div>
//                   <table className="w-full text-sm">
//                     <thead className="bg-gray-50 border-b border-gray-100">
//                       <tr>
//                         <th className="w-8 px-4 py-2" />
//                         <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">SKU / Name</th>
//                         <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">Qty Required</th>
//                         <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">Stock Available</th>
//                       </tr>
//                     </thead>
//                     <tbody className="divide-y divide-gray-50">
//                       {availableItems.map((item) => {
//                         const isChecked = selectedIds.has(item.id);
//                         return (
//                           <tr
//                             key={item.id}
//                             onClick={() => toggleOne(item.id)}
//                             className={`cursor-pointer transition ${
//                               isChecked ? "bg-[#FBD037]/10" : "hover:bg-gray-50"
//                             }`}
//                           >
//                             <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}>
//                               <div className="relative">
//                                 <input
//                                   type="checkbox"
//                                   checked={isChecked}
//                                   onChange={() => toggleOne(item.id)}
//                                   className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300
//                                     checked:border-[#FBD037] bg-white checked:bg-[#FBD037]"
//                                 />
//                                 <span className="absolute text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0
//                                   top-1/2 left-[8px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
//                                   ✓
//                                 </span>
//                               </div>
//                             </td>
//                             <td className="px-4 py-3">
//                               <p className="font-medium text-[#212121]">{item.product?.itemName ?? item.name ?? "—"}</p>
//                               <p className="text-xs text-gray-400">{item.sku ?? item.product?.sku ?? "—"}</p>
//                             </td>
//                             <td className="px-4 py-3 text-center text-[#212121]">{item.quantity}</td>
//                             <td className="px-4 py-3 text-center">
//                               <span className="text-green-600 font-medium">{item.availableStock}</span>
//                             </td>
//                           </tr>
//                         );
//                       })}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
 
//               {/* Items without stock — blocked, non-selectable */}
//               {unavailableItems.length > 0 && (
//                 <div className="border border-red-200 rounded-xl overflow-hidden">
//                   <div className="flex items-center gap-2 px-4 py-2.5 bg-red-50 border-b border-red-200">
//                     <IconAlertTriangle size={16} className="text-red-500" />
//                     <span className="text-sm font-medium text-red-600">
//                       Out of Stock — Blocked ({unavailableItems.length})
//                     </span>
//                   </div>
//                   <table className="w-full text-sm opacity-60">
//                     <thead className="bg-gray-50 border-b border-gray-100">
//                       <tr>
//                         <th className="w-8 px-4 py-2" />
//                         <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">SKU / Name</th>
//                         <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">Qty Required</th>
//                         <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">Stock Available</th>
//                       </tr>
//                     </thead>
//                     <tbody className="divide-y divide-gray-50">
//                       {unavailableItems.map((item) => (
//                         <tr key={item.id} className="cursor-not-allowed bg-gray-50">
//                           <td className="px-4 py-3">
//                             <input
//                               type="checkbox"
//                               disabled
//                               checked={false}
//                               className="h-4 w-4 appearance-none rounded border border-gray-300 bg-gray-200 cursor-not-allowed"
//                             />
//                           </td>
//                           <td className="px-4 py-3">
//                             <p className="font-medium text-[#212121]">{item.product?.itemName ?? item.name ?? "—"}</p>
//                             <p className="text-xs text-gray-400">{item.sku ?? item.product?.sku ?? "—"}</p>
//                           </td>
//                           <td className="px-4 py-3 text-center text-[#212121]">{item.quantity}</td>
//                           <td className="px-4 py-3 text-center">
//                             <span className="text-red-500 font-medium">{item.availableStock}</span>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
 
//               {/* Already split items */}
//               {alreadySplitItems.length > 0 && (
//                 <div className="border border-gray-200 rounded-xl overflow-hidden">
//                   <div className="flex items-center gap-2 px-4 py-2.5 bg-gray-50 border-b border-gray-200">
//                     <IconPackage size={16} className="text-gray-400" />
//                     <span className="text-sm font-medium text-gray-500">
//                       Already Split ({alreadySplitItems.length})
//                     </span>
//                   </div>
//                   <table className="w-full text-sm opacity-50">
//                     <tbody className="divide-y divide-gray-50">
//                       {alreadySplitItems.map((item) => (
//                         <tr key={item.id} className="cursor-not-allowed">
//                           <td className="px-4 py-3">
//                             <p className="font-medium text-[#212121]">{item.product?.itemName ?? item.name ?? "—"}</p>
//                             <p className="text-xs text-gray-400">{item.sku ?? "—"}</p>
//                           </td>
//                           <td className="px-4 py-3 text-center text-gray-400">{item.quantity}</td>
//                           <td className="px-4 py-3 text-center">
//                             <span className="text-xs bg-gray-200 text-gray-500 px-2 py-0.5 rounded-full">Split</span>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
 
//               {availableItems.length === 0 && !isLoading && (
//                 <div className="text-center py-8 text-gray-400">
//                   <IconPackage size={40} className="mx-auto mb-2 opacity-40" />
//                   <p className="text-sm">No items with available stock to split.</p>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
 
//         {/* Footer */}
//         <div className="flex items-center justify-between px-6 py-4 border-t border-gray-100 bg-gray-50">
//           <div className="text-sm text-gray-500">
//             {selectedIds.size > 0 ? (
//               <span>
//                 <strong className="text-[#212121]">{selectedIds.size}</strong> item(s) selected for split
//               </span>
//             ) : (
//               <span>Select items with available stock to split</span>
//             )}
//           </div>
//           <div className="flex gap-2">
//             <button
//               onClick={onClose}
//               className="px-5 py-2 text-sm rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleSplit}
//               disabled={isSplitting || selectedIds.size === 0}
//               className={`px-6 py-2 text-sm rounded-full font-medium transition ${
//                 isSplitting || selectedIds.size === 0
//                   ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                   : "bg-[#FBD037] text-[#212121] hover:bg-[#f2c62c]"
//               }`}
//             >
//               {isSplitting ? "Splitting..." : "Split & Create Order"}
//             </button>
//           </div>
//         </div>
//       </div>
export default function OrderSplitModal({ open, onClose, orderId, awbNumber, onSuccess, isSidebar = false }: Props) {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  const { data: lineItems, isLoading } = useFetchOrderLineItemsWithStock(orderId);
  const { mutate: splitOrder, isPending: isSplitting } = useSplitOrderMutation(orderId);

  if (!open) return null;

  const availableItems = lineItems?.filter((item) => item.hasStock && !item.isSplit) ?? [];
  const unavailableItems = lineItems?.filter((item) => !item.hasStock && !item.isSplit) ?? [];
  const alreadySplitItems = lineItems?.filter((item) => item.isSplit) ?? [];

  const allAvailableChecked =
  availableItems.length > 0 &&
  availableItems.every((item) => selectedIds.has(item.id));

  const someAvailableChecked =
  selectedIds.size > 0 && !allAvailableChecked;

  // TRUE only when ALL non-split items are selectable + selected
  const isCreateOrderMode =
  allAvailableChecked &&
  unavailableItems.length === 0;

  // TRUE when:
  // - some items selected
  // - but unavailable items still exist
  const isSplitMode =
  selectedIds.size > 0 &&
  unavailableItems.length > 0;

  const toggleAll = () => {
    if (allAvailableChecked) {
      setSelectedIds(new Set());
    } else {
      setSelectedIds(new Set(availableItems.map((item) => item.id)));
    }
  };

  const toggleOne = (id: string) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const handleSplit = () => {
    if (selectedIds.size === 0) {
      toast.error("Please select at least one item");
      return;
    }
    splitOrder(
      { selectedItemIds: Array.from(selectedIds) },
      {
        onSuccess: (data: any) => {
          if (data?.promoted) {
            toast.success("All items in stock — order promoted to New Order!");
          } else {
            toast.success(`Order split successfully! Child order: ${data.childAwb}`);
          }
          setSelectedIds(new Set());
          onSuccess();
          onClose();
        },
        onError: (error: any) => {
          toast.error(error?.message ?? "Failed. Please try again.");
        },
      }
    );
  };

  const content = (
    <div className="bg-white rounded-3xl w-full h-full flex flex-col overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 flex-shrink-0">
        <div>
          <h2 className="text-lg font-semibold text-[#212121]">
            {isCreateOrderMode ? "Create Order" : "Split Order"}
          </h2>
          <p className="text-xs text-gray-400 mt-0.5">AWB: {awbNumber}</p>
        </div>
        <button onClick={onClose} className="p-1.5 rounded-full hover:bg-gray-100 transition">
          <IconX size={18} className="text-gray-500" />
        </button>
      </div>

      {/* Body */}
      <div className="px-6 py-4 flex-1 overflow-y-auto space-y-4 min-h-0">
        {isLoading ? (
          <div className="flex justify-center items-center py-12">
            <div className="w-8 h-8 border-2 border-[#FBD037] border-t-transparent rounded-full animate-spin" />
          </div>
        ) : (
          <>
            {/* Info banner — changes based on mode */}
            <div className={`border rounded-lg px-4 py-3 text-sm ${
              isCreateOrderMode
                ? "bg-green-50 border-green-200 text-green-700"
                : "bg-amber-50 border-amber-200 text-amber-700"
            }`}>
              {isCreateOrderMode ? (
                <>
                  <strong>All in-stock items selected.</strong> Clicking "Create Order" will
                  update this order's status to <strong>New Order</strong> — no new order will be created.
                </>
              ) : (
                <>
                  <strong>How it works:</strong> Selected in-stock items will be moved into a new
                  child order (<strong>{awbNumber}-1</strong>) with status <strong>New Order</strong>.
                  Items without stock remain in this order.
                </>
              )}
            </div>

            {/* In Stock items — selectable */}
            {availableItems.length > 0 && (
              <div className="border border-green-200 rounded-xl overflow-hidden">
                <div className="flex items-center justify-between px-4 py-2.5 bg-green-50 border-b border-green-200">
                  <div className="flex items-center gap-2">
                    <IconCheck size={16} className="text-green-600" />
                    <span className="text-sm font-medium text-green-700">
                      In Stock ({availableItems.length})
                    </span>
                  </div>
                  <label className="flex items-center gap-2 text-xs text-green-600 cursor-pointer">
                    <div className="relative">
                      <input
                        type="checkbox"
                        checked={allAvailableChecked}
                        ref={(el) => { if (el) el.indeterminate = someAvailableChecked; }}
                        onChange={toggleAll}
                        className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300
                          checked:border-[#FBD037] bg-white checked:bg-[#FBD037]"
                      />
                      <span className="absolute text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0
                        top-1/2 left-[8px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                        ✓
                      </span>
                    </div>
                    Select all
                  </label>
                </div>
                <table className="w-full text-sm">
                  <thead className="bg-gray-50 border-b border-gray-100">
                    <tr>
                      <th className="w-8 px-4 py-2" />
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">SKU / Name</th>
                      <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">Qty Required</th>
                      <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">Stock Available</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50">
                    {availableItems.map((item) => {
                      const isChecked = selectedIds.has(item.id);
                      return (
                        <tr
                          key={item.id}
                          onClick={() => toggleOne(item.id)}
                          className={`cursor-pointer transition ${isChecked ? "bg-[#FBD037]/10" : "hover:bg-gray-50"}`}
                        >
                          <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}>
                            <div className="relative">
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() => toggleOne(item.id)}
                                className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300
                                  checked:border-[#FBD037] bg-white checked:bg-[#FBD037]"
                              />
                              <span className="absolute text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0
                                top-1/2 left-[8px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                                ✓
                              </span>
                            </div>
                          </td>
                          <td className="px-4 py-3">
                            <p className="font-medium text-[#212121]">{item.product?.itemName ?? item.name ?? "—"}</p>
                            <p className="text-xs text-gray-400">{item.sku ?? item.product?.sku ?? "—"}</p>
                          </td>
                          <td className="px-4 py-3 text-center text-[#212121]">{item.quantity}</td>
                          <td className="px-4 py-3 text-center">
                            <span className="text-green-600 font-medium">{item.availableStock}</span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}

            {/* Out of stock — blocked */}
            {unavailableItems.length > 0 && (
              <div className="border border-red-200 rounded-xl overflow-hidden">
                <div className="flex items-center gap-2 px-4 py-2.5 bg-red-50 border-b border-red-200">
                  <IconAlertTriangle size={16} className="text-red-500" />
                  <span className="text-sm font-medium text-red-600">
                    Out of Stock — Blocked ({unavailableItems.length})
                  </span>
                </div>
                <table className="w-full text-sm opacity-60">
                  <thead className="bg-gray-50 border-b border-gray-100">
                    <tr>
                      <th className="w-8 px-4 py-2" />
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">SKU / Name</th>
                      <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">Qty Required</th>
                      <th className="px-4 py-2 text-center text-xs font-medium text-gray-500">Stock Available</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50">
                    {unavailableItems.map((item) => (
                      <tr key={item.id} className="cursor-not-allowed bg-gray-50">
                        <td className="px-4 py-3">
                          <input type="checkbox" disabled checked={false}
                            className="h-4 w-4 appearance-none rounded border border-gray-300 bg-gray-200 cursor-not-allowed" />
                        </td>
                        <td className="px-4 py-3">
                          <p className="font-medium text-[#212121]">{item.product?.itemName ?? item.name ?? "—"}</p>
                          <p className="text-xs text-gray-400">{item.sku ?? item.product?.sku ?? "—"}</p>
                        </td>
                        <td className="px-4 py-3 text-center text-[#212121]">{item.quantity}</td>
                        <td className="px-4 py-3 text-center">
                          <span className="text-red-500 font-medium">{item.availableStock}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Already split */}
            {alreadySplitItems.length > 0 && (
              <div className="border border-gray-200 rounded-xl overflow-hidden">
                <div className="flex items-center gap-2 px-4 py-2.5 bg-gray-50 border-b border-gray-200">
                  <IconPackage size={16} className="text-gray-400" />
                  <span className="text-sm font-medium text-gray-500">
                    Already Split ({alreadySplitItems.length})
                  </span>
                </div>
                <table className="w-full text-sm opacity-50">
                  <tbody className="divide-y divide-gray-50">
                    {alreadySplitItems.map((item) => (
                      <tr key={item.id} className="cursor-not-allowed">
                        <td className="px-4 py-3">
                          <p className="font-medium text-[#212121]">{item.product?.itemName ?? item.name ?? "—"}</p>
                          <p className="text-xs text-gray-400">{item.sku ?? "—"}</p>
                        </td>
                        <td className="px-4 py-3 text-center text-gray-400">{item.quantity}</td>
                        <td className="px-4 py-3 text-center">
                          <span className="text-xs bg-gray-200 text-gray-500 px-2 py-0.5 rounded-full">Split</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {availableItems.length === 0 && !isLoading && (
              <div className="text-center py-8 text-gray-400">
                <IconPackage size={40} className="mx-auto mb-2 opacity-40" />
                <p className="text-sm">No items with available stock.</p>
              </div>
            )}
          </>
        )}
      </div>

      {/* Footer */}
      <div className="flex items-center justify-between px-6 py-4 border-t border-gray-100 bg-gray-50 flex-shrink-0">
        <div className="text-sm text-gray-500">
          {selectedIds.size > 0 ? (
            <span>
              <strong className="text-[#212121]">{selectedIds.size}</strong>{" "}
              item(s) selected
              {isCreateOrderMode && (
                <span className="ml-1 text-green-600 font-medium">— will promote to New Order</span>
              )}
            </span>
          ) : (
            <span>Select items with available stock</span>
          )}
        </div>
        <div className="flex gap-2">
          <button
            onClick={onClose}
            className="px-5 py-2 text-sm rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleSplit}
            disabled={isSplitting || selectedIds.size === 0}
            className={`px-6 py-2 text-sm rounded-full font-medium transition ${
              isSplitting || selectedIds.size === 0
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : isCreateOrderMode
                  ? "bg-green-500 text-white hover:bg-green-600"
                  : "bg-[#FBD037] text-[#212121] hover:bg-[#f2c62c]"
            }`}
          >
            {isSplitting
              ? "Processing..."
              : isCreateOrderMode
                ? "Create Order"
                : "Split & Create Order"}
          </button>
        </div>
      </div>
    </div>
  );

  if (isSidebar) return content;

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-end p-4">
      <div className="rounded-2xl w-full max-w-[500px] h-[calc(100vh-2rem)] flex flex-col relative bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] shadow-2xl overflow-hidden animate-in fade-in slide-in-from-right duration-300">
        {content}
      </div>
    </div>
  );
}